import { ROUTE_ROOT_PAGE_PUBLIC } from '@/constants/routes';
/**
 * Genera el link para un grupo de recursos
 */
export function getLink(id: string): string {
	return `${window.location.protocol}//${document.location.host}${ROUTE_ROOT_PAGE_PUBLIC.replace(':id', id)}`;
}

export default {
	getLink,
};
